/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELResourceMetrics,
  OTELResourceMetrics$Outbound,
  OTELResourceMetrics$outboundSchema,
} from "./otelresourcemetrics.js";

/**
 * OTEL metrics export payload
 */
export type OTELMetricsPayload = {
  /**
   * Array of resource metrics
   */
  resourceMetrics?: Array<OTELResourceMetrics> | undefined;
};

/** @internal */
export type OTELMetricsPayload$Outbound = {
  resourceMetrics?: Array<OTELResourceMetrics$Outbound> | undefined;
};

/** @internal */
export const OTELMetricsPayload$outboundSchema: z.ZodMiniType<
  OTELMetricsPayload$Outbound,
  OTELMetricsPayload
> = z.object({
  resourceMetrics: z.optional(z.array(OTELResourceMetrics$outboundSchema)),
});

export function otelMetricsPayloadToJSON(
  otelMetricsPayload: OTELMetricsPayload,
): string {
  return JSON.stringify(
    OTELMetricsPayload$outboundSchema.parse(otelMetricsPayload),
  );
}
